import { Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { styled } from 'styled-components'

interface HighlightedPaymentMethodProps {
  icon?: string
  text?: string
}

const Wrapper = styled(Typography)`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  padding: 4px;
  margin-bottom: 0;
`
const PaymentMethodImg = styled.img`
  height: 24px;
  width: auto;
`

export function HighlightedPaymentMethod({ icon, text }: HighlightedPaymentMethodProps) {
  if (!icon || !text) {
    return null
  }

  return (
    <Wrapper as="div">
      <PaymentMethodImg src={icon} alt={text} />
      {text}
    </Wrapper>
  )
}
